import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { Box } from '@mui/material';
import { ROLES } from '../../utils/appRoles';
import axios, { unAuthAxios } from '../../utils/axios';
import FormGroup from '../shared/containers/FormGroup';
import Input from '../shared/formInput/Input';
import SelectInput from '../shared/formInput/SelectInput';
import PrimaryButton from '../shared/buttons/PrimaryButton';
import { useEffect, useState } from 'react';
import { handleExcludedFields } from '../../utils/form';
import SwitchInput from '../shared/formInput/SwitchInput';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const RequestNewPasswordForm = ({submitButtonChildren='envoyer'}) => {
    const navigate = useNavigate();
    
    const initialValues = {
        email: '',
        password_forgotten: true
    };

    const onSubmit = async (values, {resetForm, setErrors, setSubmitting, setDirty}) => {
        try {
            await unAuthAxios.patch(`user/reset_password/`, values);
            navigate('/', {replace: true});
            // keep the values after submission and dirty to false
        } catch (error) {
            setErrors({createError: error.message})
            // console.error(error)
        }
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .required("champ requis")
            .email("format: utilisateur@domaine.fr"),
    });

    const formStyle = {
        border: "1px solid", // TODO: put in theme
        borderColor: "primary.main",
        borderRadius: "4px",
        width: "fit-content",
        padding: "2em",
    };

    return (
        <Formik {...{ initialValues, onSubmit, validationSchema}}>
            {({errors, isValid, dirty}) => (
                <Box sx={formStyle}>
                    {errors.createError && <p>{errors.createError}</p>}
                    <Form autoComplete="off">
                        
                        <FormGroup>
                            <Input
                                {...{
                                    name: "email",
                                    label: "Email",
                                }}
                            />
                        </FormGroup>
                        <PrimaryButton type="submit" disabled={!isValid || !dirty}>
                            {submitButtonChildren}
                        </PrimaryButton>
                    </Form>
                </Box>
            )}
        </Formik>
    );
}



export default RequestNewPasswordForm;